import findResult, { findWithCodes, removeItemByCode } from '@/utils/resultsHelper';
import withDraft from '@/utils/draftHelper';
import { datasetNamespacesCategories } from '../constants';

const initialState = {
  namespaces: {
    open: {
      results: [],
    },
  },
};

export const findDatasetNamespaces = ({ namespaces }, { category, code }) => (
  findResult(namespaces, category, code)
);

export const findAllDatasetNamespaces = ({ namespaces }, { items }) => {
  const codes = items.map(({ code }) => code);
  return findWithCodes(namespaces, datasetNamespacesCategories, codes);
};

export const closeDatasetNamespacesState = withDraft((draft, { category, code }) => {
  const item = findDatasetNamespaces(draft, { category, code });

  if (item) {
    draft.namespaces[category].results = removeItemByCode(draft.namespaces[category].results, item);
  }
});

export default initialState;
